import {
    BonusesPayment,
    ConnectAutoPay,
    EmailInput,
    PaymentFieldWrapper,
    PaymentSumInput,
    TwoFieldWrapper,
} from '~/src/features/payments-abn/components/PaymentForms';

/**
 * Форма для оплаты картой
 */
export const CardPaymentForm = (): JSX.Element => {
    return (
        <PaymentFieldWrapper>
            <TwoFieldWrapper>
                <PaymentSumInput/>
                <EmailInput/>
            </TwoFieldWrapper>

            <ConnectAutoPay/>

            <BonusesPayment/>
        </PaymentFieldWrapper>
    );
};
